var map = {
	"./gallery1.jpg": 5701,
	"./gallery10.jpg": 1023,
	"./gallery11.jpg": 209,
	"./gallery12.jpg": 2204,
	"./gallery13.jpg": 3949,
	"./gallery14.jpg": 5592,
	"./gallery15.jpg": 6332,
	"./gallery2.jpg": 6631,
	"./gallery3.jpg": 2896,
	"./gallery4.jpg": 2573,
	"./gallery5.jpg": 9187,
	"./gallery6.jpg": 561,
	"./gallery7.jpg": 5725,
	"./gallery8.jpg": 8578,
	"./gallery9.jpg": 9806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9282;